const AGENDA_EQUIPO_VIEWERS = new Set(['javier.vazquez@sienindustrial.com.mx']);

export const canViewAgendaEquipo = (email?: string | null): boolean => {
  if (!email) return false;
  return AGENDA_EQUIPO_VIEWERS.has(email.trim().toLowerCase());
};
